import React from "react";

const AddEvent = () => {
  return (
    <div className="cmt-100">
      <h3 className="text-center custom-sub-title cmb-30">add events</h3>
    </div>
  );
};

export default AddEvent;
